module.exports = __webpack_public_path__ + "media/sub3-5-3.d2b0c994.mp4";